import SorbonneLogo from '../img/sorbonne.png';
import GustaveLogo from '../img/gustave.png';

export default function Formations () {
  return (
    <div className="formations-container">

      <h1 className="title">Formations</h1>

      <div className="formations-wrapper">

      <div className="formation-wrapper">
        <div className="formation-title">IMAC <span style={{ fontSize: '33px', marginLeft: '5px' }}>[2015- 2018]</span></div>
        <div className="formation-subtitle">
          <div style={{ fontWeight: '600', marginBottom: '5px' }}>École d’Ingénieur alliant informatique et arts à l’université Paris Est Marne-la-vallée</div>
          <img alt="gustave-logo" src={GustaveLogo} style={{ width: '200px', marginTop: '15px'}}/>
        </div>
      </div>

      <div className="formation-wrapper" style={{ marginRight: '40px'}}>
        <div className="formation-title">L1 et L2 informatique</div>
        <div className="formation-title" style={{ fontSize: '33px', marginTop: '0px'}}>[2013 - 2015]</div>
        <div className="formation-subtitle">
          <div style={{ fontWeight: '600', marginBottom: '5px'  }}>Université Pierre et Marie Curie</div>
           <img alt="sorbonne-logo" src={SorbonneLogo} style={{ width: '130px', marginTop: '15px'}}/>
        </div>
      </div>

      <div className="formation-wrapper" style={{ marginRight: '40px'}}>
        <div className="formation-title">BAC Scientifique<span style={{ fontSize: '33px', marginLeft: '5px' }}>[2013]</span></div>
        <div className="formation-subtitle" style={{marginBottom: '60px'}}>
          <div style={{ fontWeight: '600', marginBottom: '5px'  }}>Lycée Rodin - Paris <span style={{ fontFamily: 'calibri', fontWeight: 600 }}>13</span></div>
        </div>
      </div>

      </div>

    </div>
  );
}
